import 'containers/common/Detail.css';
import PropertyAddList from "containers/property/PropertyAddList";
import React, { Component } from "react";
import { Modal } from "react-bootstrap";




export default class PropertyAddModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
         
            isLoading: true            
        };
     
       
    }
    

    async componentDidMount() {
        
        if (!this.props.isAuthenticated) { // if false
            return;
        }

        if (!this.props.show) {
            return null;
        }

           
    }

    


    renderComponent() {
        return (
            
            <Modal
                show={this.props.show}
                onHide={this.props.togglePropertyAddModal}
                dialogClassName="modal-90w"
                >
                <Modal.Header closeButton>
                    <Modal.Title>Add Properties</Modal.Title>
                </Modal.Header>
                <Modal.Body>
           
              
                    
                    <PropertyAddList
                        filter={this.props.filter}
                        isAuthenticated={this.props.isAuthenticated}
                        isLoading={this.state.isLoading}
                        controlType="table"
                        saveForm={this.props.saveForm}
                        user={this.props.user}
                        data={this.props.data}
                        updateTableState={this.props.updateTableState}
                        saveRecord={this.props.saveRecord}
                        deleteRecord={this.props.deleteRecord}
                        validateRelatedRecord={this.props.validateRelatedRecord}
                        propertyid={this.props.propertyid}
                        suburbOptions={this.props.suburbOptions}
                        cityscopeOptions={this.props.cityscopeOptions}
                        />

                    
          
                    </Modal.Body>
            </Modal>
        );
    }
    
    


    render() {
        return (

            <div className="Edit">
                {this.props.isAuthenticated ? this.renderComponent() : console.log("error)")}
            </div>
        );
    }
}
